import { render, staticRenderFns } from "./news_page_item.vue?vue&type=template&id=64448dca"
import script from "./news_page_item.vue?vue&type=script&lang=js"
export * from "./news_page_item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports